import { render, staticRenderFns } from "./TestTable3.vue?vue&type=template&id=1aaa456b"
import script from "./TestTable3.vue?vue&type=script&lang=js"
export * from "./TestTable3.vue?vue&type=script&lang=js"
import style0 from "./TestTable3.vue?vue&type=style&index=0&id=1aaa456b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports